import request from '@/utils/request'

export const getNotSure = (data) => {
  return request({
    url: '/dataSure/getNotSureList',
    method: 'post',
    params: data
  })
}

export const sureDataByBatchId = (data) => {
  return request({
    url: '/dataSure/sureDataByBatchId',
    method: 'post',
    params: data
  })
}

export const deleteDataByBatchId = (data) => {
  return request({
    url: '/dataSure/deleteDataByBatchId',
    method: 'post',
    params: data
  })
}

export const listData = (data) => {
  return request({
    url: '/dataImport/listData',
    method: 'post',
    params: data
  })
}
